var render = function render(){var _vm=this,_c=_vm._self._c;return _c('donut-chart08-template',{attrs:{"board-ids":[108, 156, 157, 158, 159],"data-type":_vm.dataType,"field-code":"workplace-material","graph-id":54,"title":"(원료·제조물 사업장) 유해·위험요인 조사 현황","unit":"건"}})
}
var staticRenderFns = []

export { render, staticRenderFns }